import { MoneyMapCategorySection } from '@fruitful/money-map';
import {
    type DeepPartial,
    type MoneyMapAccountWithAccountDetails,
    MoneyMapCategory,
    type MoneyMapRuleWithAccountDetails,
    type MoneyMapWithRulesAndAccounts,
} from '@fruitful/types';
import { YStack } from 'smoothie';

import {
    PreviewSection,
    PreviewSectionIconMap,
} from '../../types/PreviewSection';
import { PreviewContainer } from './PreviewContainer';
import PreviewSectionHeader from './PreviewSectionHeader';

interface MoneyMapPreviewAccountsProps {
    moneyMap: MoneyMapWithRulesAndAccounts;
    accounts: MoneyMapAccountWithAccountDetails[];
    billRules: Array<DeepPartial<MoneyMapRuleWithAccountDetails>>;
    spendRules: Array<DeepPartial<MoneyMapRuleWithAccountDetails>>;
    goalRules: Array<DeepPartial<MoneyMapRuleWithAccountDetails>>;
    otherAccountRules: Array<DeepPartial<MoneyMapRuleWithAccountDetails>>;
    billsTotalCents: number | null;
    spendTotalCents: number | null;
    goalsTotalCents: number | null;
}

export const PreviewAccounts = ({
    moneyMap,
    accounts,
    billRules,
    spendRules,
    goalRules,
    otherAccountRules,
    billsTotalCents,
    spendTotalCents,
    goalsTotalCents,
}: MoneyMapPreviewAccountsProps) => {
    return (
        <PreviewContainer>
            <YStack gap={8} maxWidth={640}>
                <PreviewSectionHeader
                    icon={PreviewSectionIconMap[PreviewSection.ACCOUNTS]}
                    title={PreviewSection.ACCOUNTS}
                />
                <MoneyMapCategorySection
                    category={MoneyMapCategory.BILLS}
                    moneyMap={moneyMap}
                    accounts={accounts}
                    totalAmountCents={billsTotalCents}
                    rules={billRules as MoneyMapRuleWithAccountDetails[]}
                />
                <MoneyMapCategorySection
                    category={MoneyMapCategory.SPEND}
                    moneyMap={moneyMap}
                    accounts={accounts}
                    totalAmountCents={spendTotalCents}
                    rules={spendRules as MoneyMapRuleWithAccountDetails[]}
                />
                <MoneyMapCategorySection
                    category={MoneyMapCategory.GOALS}
                    moneyMap={moneyMap}
                    accounts={accounts}
                    totalAmountCents={goalsTotalCents}
                    rules={goalRules as MoneyMapRuleWithAccountDetails[]}
                />
                {otherAccountRules.length > 0 && (
                    <MoneyMapCategorySection
                        category={MoneyMapCategory.OTHER_ACCOUNTS}
                        moneyMap={moneyMap}
                        accounts={accounts}
                        totalAmountCents={null}
                        rules={
                            otherAccountRules as MoneyMapRuleWithAccountDetails[]
                        }
                    />
                )}
            </YStack>
        </PreviewContainer>
    );
};
